import React from "react";
import imageUrl from "utils/imageUrl";
function Invest() {
  return (
    <section className="why__invest__two section__space">
      <div className="container">
        <div className="why__invest__two__area wow fadeInUp">
          <div className="section__header">
            <h5 className="neutral-top">Smarter Property Investing</h5>
            <h2>For Renters</h2>
            <p className="neutral-bottom">
              Start building your real estate investment portfolio today with as
              little as € 100.
            </p>
          </div>
          <div className="row">
            <div className="col-sm-6 col-xxl-3">
              <div className="why__invest__two__single__item">
                <img
                  src={imageUrl("icons/secure.png")}
                  alt="Secure Investment"
                />
                <h5>No Collateral Required</h5>
                <p className="neutral-bottom">
                  More accessible, more practical
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-xxl-3">
              <div className="why__invest__two__single__item">
                <img
                  src={imageUrl("icons/transparent.png")}
                  alt="Transparent Platform"
                />
                <h5>Rent on Demand</h5>
                <p className="neutral-bottom">
                  Start using your NFT as soon as it's rented, no need to wait
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-xxl-3">
              <div className="why__invest__two__single__item">
                <img
                  src={imageUrl("icons/cashout.png")}
                  alt="Cash out any time"
                />
                <h5>Automatic Expiration</h5>
                <p className="neutral-bottom">
                  No hassle of returning NFTs, saving time and gas
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-xxl-3">
              <div className="why__invest__two__single__item">
                <img src={imageUrl("icons/reinvest.png")} alt="Reinvest" />
                <h5>Easy Subletting</h5>
                <p className="neutral-bottom">
                  Rent out an NFT you are renting
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Invest;
